import { Location } from '@angular/common';
import { Component, HostListener, OnInit, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { filter, firstValueFrom, Subject, Subscription } from 'rxjs';
import { CustomInitialConsecutiveComponent } from 'src/app/components/custom-initial-consecutive/custom-initial-consecutive.component';
import { CustomModalComponent } from 'src/app/components/custom-modal/custom-modal.component';
import { AuthenticationContants } from 'src/app/constants/authentication-constants';
import { ProjectName } from 'src/app/constants/project-name-constants';
import { TransferWorkshopStoreStateEnums } from 'src/app/enum/transfer-workshop-store-enum';
import { CustomListDropdown } from 'src/app/interfaces/custom-list/custom-list-dropdown.interface';
import { UserModel } from 'src/app/models/authentication/user.model';
import { TransferWorkshopStoreModel } from 'src/app/models/maintenance/transfer-workshop-store.model';
import { TransferWorkshopStorePrintModel } from 'src/app/models/print/maintenance/transfer-workshop-store-print.model';
import { MechanicService } from 'src/app/services/archive/mechanic.service';
import { WindowService } from 'src/app/services/authentication/window.service';
import { DateConverterService } from 'src/app/services/global-services/date-converter.service';
import { UserAuthenticatedService } from 'src/app/services/global-services/user-authenticated.service';
import { HeaderService } from 'src/app/services/header/header.service';
import { TransferWorkshopStoreService } from 'src/app/services/maintenance/transfer-workshop-store.service';
import { BranchService } from 'src/app/services/management/branch.service';
import { ToastHandlerService } from 'src/app/services/toast/toast-handler.service';
import Swal from 'sweetalert2';


@Component({
  selector: 'app-register-transfer-workshop-store',
  templateUrl: './register-transfer-workshop-store.component.html',
  styleUrls: ['./register-transfer-workshop-store.component.scss'],
  standalone: false
})
export class RegisterTransferWorkshopStoreComponent implements OnInit {

  @ViewChild('initialConsecutive') initialConsecutiveModalComponent?: CustomModalComponent | null = null;

  branchId: number = 0;
  companyId: number = 0;
  componentInitialConsecutiveModal = CustomInitialConsecutiveComponent;
  disabledForm: boolean = false;
  formTransferWorkshopStore: FormGroup = new FormGroup({});
  hasQuantityInZero: boolean = false;
  icon: string = '';
  isOpened: string | undefined = undefined;
  listBranches: CustomListDropdown[] = [];
  listMechanics: any[] = [];
  listTypes: CustomListDropdown[] = [
    { label: 'Limpieza', value: 2 },
    { label: 'Reparación', value: 3 }
  ];
  listObservers: Array<Subscription> = new Array<Subscription>();
  mechanicId: number = 0;
  nameWindow: string = 'Captura Traslado Taller Almacén';
  output$ = new Subject<any>();
  permissionPrint: boolean = false;
  permissionUpdatable: boolean = false;
  projectName = ProjectName.projectName;
  quantityDetails: number = 0;
  reloadPrint: boolean = false;
  severityState: string = 'success';
  stateTransferStoreWorkshop: string = '';
  subscription: Subscription;
  titleState: string = '';
  transferWorkshopStoreContract: TransferWorkshopStoreModel = new TransferWorkshopStoreModel();
  transferWorkshopStorePrintModel: TransferWorkshopStorePrintModel = new TransferWorkshopStorePrintModel();
  transferWorkshopStoreId: number = 0;
  userAuthenticated: UserModel = new UserModel();
  url: string = 'transfer-workshop-store'

  constructor(
    private activatedRoute: ActivatedRoute,
    private branchService: BranchService,
    private dateConverterService: DateConverterService,
    private formBuilder: FormBuilder,
    private headerService: HeaderService,
    private location: Location,
    private title: Title,
    private mechanicService: MechanicService,
    private toastHandlerService: ToastHandlerService,
    private userAuthenticatedService: UserAuthenticatedService,
    private windowService: WindowService,
    private transferWorkshopStoreService: TransferWorkshopStoreService) {
    this.validateForm(new TransferWorkshopStoreModel());
  }

  async ngOnInit() {
    this.headerService.setTitle(this.nameWindow);
    this.title.setTitle(`${this.nameWindow} - ${this.projectName}`);
    await this.getPermission();
    this.activatedRoute.params.subscribe(params => {
      this.transferWorkshopStoreId = Object.keys(params).length > 0 ? params?.id : null;
    });

    this.subscription = this.output$.subscribe(async ({ type, payload }) => {
      if (type === 'initialConsecutive') {
        this.formTransferWorkshopStore.patchValue({
          consecutive: payload.consecutive
        });
        await this.send();
      }
    });

    this.handleInitialState();
  }

  @HostListener('window:beforeunload')
  beforeUnloadHandler() {
    this.ngOnDestroy();
  }

  async ngOnDestroy() {
    this.listObservers.forEach(sub => sub.unsubscribe());
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      const window = windowsOpened.findIndex(x => x === this.url);
      if (window != -1) {
        windowsOpened.splice(window, 1);
        localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      }
    }
  }

  async annulTransferWorkshopStore() {
    if (!this.transferWorkshopStoreId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
    }
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `El usuario no tiene permisos para anular traslados.
        Comuníquese con el administrador del sistema.`);
    }
    if (this.transferWorkshopStoreContract.swBlock) {
      return this.toastHandlerService.showToast('warning', `El traslado se encuentra actualmente bloqueado.
        Comuníquese con el administrador del sistema.`);
    }
    if (this.quantityDetails !== 0) {
      return this.toastHandlerService.showToast('warning', 'No se puede anular un traslado con detalle.');
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: "¿Realmente desea anular el traslado?",
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No'
    });
    if (result.isConfirmed) {
      try {
        const response = await firstValueFrom(this.transferWorkshopStoreService.annulAsync(this.transferWorkshopStoreId));
        this.transferWorkshopStoreContract = response;
        this.validateForm(this.transferWorkshopStoreContract);
        this.toastHandlerService.showToast('success', 'El traslado se anuló exitosamente.');
      } catch (error) {
        console.error('Error al anular el traslado.', error);
      }
    }
  }

  async blockTransferWorkshopStore(value: boolean) {
    if (!this.transferWorkshopStoreId) {
      this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
      return setTimeout(() => this.formTransferWorkshopStore.controls["swBlock"].patchValue(!value));
    }
    if (this.transferWorkshopStoreContract.transferWorkshopStoreState == TransferWorkshopStoreStateEnums.open) {
      setTimeout(() => this.formTransferWorkshopStore.controls["swBlock"].patchValue(!value));
      return this.toastHandlerService.showToast('warning', 'No es posible bloquear el traslado mientras se encuentre en estado abierto.');
    }
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.blockAsync(this.transferWorkshopStoreId));
      this.transferWorkshopStoreContract = response;
      this.validateForm(this.transferWorkshopStoreContract);
    } catch (error) {
      console.error('Error al bloquear el traslado.', error);
    }
  }

  async changeBranch(branchId: number) {
    this.branchId = branchId;
    await this.getAllLists('mechanics');
    this.resetContract();
  }

  async createNewRegister() {
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('warning', `El usuario no tiene permisos para crear un traslado.
        Comuníquese con el administrador del sistema.`);
    }
    this.resetContract();
  }

  async changeConsecutive(consecutive: number) {
    this.branchId = this.formTransferWorkshopStore.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    if (!consecutive) {
      this.resetContract();
      return;
    }
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.getTransferWorkshopStoreByKeysAsync(this.branchId,
        consecutive));
      this.transferWorkshopStoreId = response.transferWorkshopStoreId;
      this.transferWorkshopStoreContract = response;
      this.validateForm(this.transferWorkshopStoreContract);
      this.location.replaceState(`/${this.url}/register/${this.transferWorkshopStoreId}`);
    } catch (error) {
      console.error('Error al buscar el traslado.', error);
    }
  }

  changeTransferWorkshopStoreType(currentType: number) {
    const previousType = this.transferWorkshopStoreContract.type;
    if ((currentType != previousType) && this.quantityDetails != 0) {
      setTimeout(() => this.formTransferWorkshopStore.controls["type"].patchValue(previousType));
      this.toastHandlerService.showToast('warning', 'No puede cambiarse el tipo del traslado mientras tenga detalle.');
    }
  }

  async changeTransferWorkshopStoreState() {
    const { transferWorkshopStoreId, swBlock } = this.transferWorkshopStoreContract;
    if (!transferWorkshopStoreId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
    }
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `No tiene permisos para cambiar el estado del traslado.
        Comuníquese con el administrador del sistema.`);
    }
    if (swBlock) {
      return this.toastHandlerService.showToast('warning', `El traslado se encuentra actualmente bloqueado.
        Comuníquese con el administrador del sistema.`);
    }
    if (this.hasQuantityInZero) {
      return this.toastHandlerService.showToast('warning', 'No puede cambiar el estado del traslado si tiene detalles con cantidades en cero.');
    }
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.changeStateAsync(transferWorkshopStoreId));
      this.transferWorkshopStoreContract = response;
      this.validateForm(this.transferWorkshopStoreContract);
      const successMessage = response.transferWorkshopStoreState ? 'El traslado fue abierto exitosamente.'
        : 'El traslado fue abierto fue cerrado exitosamente.';
      this.toastHandlerService.showToast('success', successMessage);
    } catch (error) {
      console.error('Error al cambiar el estado de el traslado.', error);
    }
  }

  async createTransferWorkshopStore(modelTransferWorkshopStore: TransferWorkshopStoreModel) {
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.createAsync(modelTransferWorkshopStore));
      this.transferWorkshopStoreId = response.transferWorkshopStoreId;
      this.transferWorkshopStoreContract = response;
      this.validateForm(this.transferWorkshopStoreContract);
      this.toastHandlerService.showToast('success', `El traslado fue creado exitosamente.`);
      this.location.replaceState(`/${this.url}/register/${this.transferWorkshopStoreId}`);
    } catch (error) {
      console.error('Error al crear el traslado.', error);
      setTimeout(() => this.formTransferWorkshopStore.controls["consecutive"].patchValue(0));
    }
  }

  async deleteTransferWorkshopStore() {
    if (!this.transferWorkshopStoreId) {
      return this.toastHandlerService.showToast('warning', 'Debe crear un traslado.');
    }
    if (!this.permissionUpdatable) {
      return this.toastHandlerService.showToast('error', `El usuario no tiene permisos para eliminar el traslado.
        Comuníquese con el administrador del sistema.`);
    }
    const result = await Swal.fire({
      title: 'Atención',
      text: '¿Realmente desea eliminar el traslado?',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#3085d6',
      cancelButtonColor: '#d33',
      confirmButtonText: 'Sí',
      cancelButtonText: 'No',
    });
    if (result.isConfirmed) {
      try {
        await firstValueFrom(this.transferWorkshopStoreService.deleteAsync(this.transferWorkshopStoreId));
        this.createNewRegister();
        this.toastHandlerService.showToast('success', 'El traslado fue eliminado exitosamente.');
      } catch (error) {
        console.error('Error al eliminar el traslado.', error);
      }
    }
  }

  finishLoading(finishPrint: boolean) {
    if (finishPrint) {
      window.print();
    }
  }

  async getAllLists(...listsToLoad: Array<'branches' | 'mechanics'>) {
    try {
      const lists = {
        branches: async () => {
          this.listBranches = await firstValueFrom(
            this.branchService.getAllBranchesForSelectAsync()
          );
        },
        mechanics: async () => {
          this.listMechanics = await firstValueFrom(
            this.mechanicService.getAllMechanicsForSelectAsync(this.branchId)
          );
          const defaultMechanic = this.listMechanics.find(x => x.isDefault);
          if (defaultMechanic) {
            this.mechanicId = defaultMechanic.value;
          }
        },
      };
      if (listsToLoad.length) {
        await Promise.all(listsToLoad.map(list => lists[list]()));
      } else {
        await Promise.all([
          lists.branches(),
          lists.mechanics(),
        ]);
      }
    } catch (error) {
      console.error('Error obtener las listas.', error);
    }
  }

  async getButtonClick(buttonClick: any) {
    this.branchId = this.formTransferWorkshopStore.get("branchId")?.value;
    if (!this.branchId) {
      return this.toastHandlerService.showToast('warning', 'Seleccione una sucursal.');
    }
    await this.handleTransferWorkshopStoreNavigation(buttonClick, this.branchId)
  }

  async getFirstBranchByUserAuthenticated() {
    try {
      const response = await firstValueFrom(this.branchService.getFirstBranchByUserAuthenticatedAsync());
      this.branchId = response.branchId;
      await this.getAllLists();
    } catch (error) {
      this.branchId = 0;
      console.error('Error al obtener la sucursal principal del usuario.', error);
    }
  }

  async onSave() {
    this.validateFormControls();
    if (!this.formTransferWorkshopStore.valid) {
      this.showValidationMessages();
      return;
    }
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.hasExistingTransferWorkshopStore(this.branchId));
      if (!response) {
        this.initialConsecutiveModalComponent?.show();
        return;
      }
      await this.send();
    } catch (error) {
      console.error('Error al buscar el ultimo traslado.', error);
    }
  }

  async getPermission() {
    const windowsOpenedJson = localStorage.getItem(AuthenticationContants.keyWindowsOpenedLocalStorage);
    if (windowsOpenedJson) {
      const windowsOpened: Array<string> = JSON.parse(windowsOpenedJson);
      this.isOpened = windowsOpened.find(x => x === this.url);
      windowsOpened.push(this.url);
      localStorage.setItem(AuthenticationContants.keyWindowsOpenedLocalStorage, JSON.stringify(windowsOpened));
      if (this.isOpened) {
        this.toastHandlerService.showToast('error', `No se permite tener dos ventanas/pestañas de ${this.nameWindow} abiertas.`);
      }
    } else {
      localStorage.clear();
    }
    this.getUserAuthenticated();
    await Promise.all([
      this.getPermissionPrint(),
      this.getPermissionProfileByUrl(),
    ]);
  }

  async getPermissionPrint() {
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.getPermissionPrintAsync());
      this.permissionPrint = response;
    } catch (error) {
      console.error('Error al buscar los permisos de impresión.', error);
    }
  }

  async getPermissionProfileByUrl() {
    try {
      const response = await firstValueFrom(this.windowService.getPermissionProfileByUrl(this.url));
      this.permissionUpdatable = response;
    } catch (error) {
      console.error('Error al buscar los permisos del perfil.', error);
    }
  }

  async getTransferWorkshopStoreById() {
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.getByIdAsync(this.transferWorkshopStoreId));
      this.branchId = response.branchId;
      await this.getAllLists();
      this.transferWorkshopStoreContract = response;
      this.validateForm(this.transferWorkshopStoreContract);
    } catch (error) {
      console.error('Error al obtener el traslado.', error);
    }
  }

  getUserAuthenticated() {
    const load = this.userAuthenticatedService.userObservable.pipe(filter(user => user && user.userId !== 0))
      .subscribe(user => {
        this.userAuthenticated = user;
        this.companyId = user.companyId;
      });
    this.listObservers.push(load);
  }

  async handleInitialState() {
    if (this.transferWorkshopStoreId) {
      await this.getTransferWorkshopStoreById();
    } else {
      await this.getFirstBranchByUserAuthenticated();
      this.createNewRegister();
    }
  }

  async handleTransferWorkshopStoreNavigation(buttonClick: any, branchId: number) {
    const consecutive = this.formTransferWorkshopStore.get("consecutive")?.value;
    const actionMap: Record<string, () => Promise<TransferWorkshopStoreModel>> = {
      first: () =>
        firstValueFrom(this.transferWorkshopStoreService.getFirstTransferWorkshopStoreByKeysAsync(branchId)),
      previus: () =>
        firstValueFrom(this.transferWorkshopStoreService.getPreviusTransferWorkshopStoreByKeysAsync(branchId, consecutive)),
      next: () =>
        firstValueFrom(this.transferWorkshopStoreService.getNextTransferWorkshopStoreByKeysAsync(branchId, consecutive)),
      last: () =>
        firstValueFrom(this.transferWorkshopStoreService.getLastTransferWorkshopStoreByKeysAsync(branchId)),
    };
    const action = actionMap[buttonClick.target.id];
    if (!action) {
      this.resetContract();
      return;
    }
    try {
      const transferWorkshopStore = await action();
      this.transferWorkshopStoreId = transferWorkshopStore.transferWorkshopStoreId;
      this.transferWorkshopStoreContract = transferWorkshopStore;
      this.validateForm(this.transferWorkshopStoreContract);
      this.location.replaceState(`/${this.url}/register/${this.transferWorkshopStoreId}`);
    } catch (error) {
      console.error(`Error al buscar el traslado (${buttonClick.target.id}).`, error);
    }
  }

  async printPage() {
    if (!this.transferWorkshopStoreId) {
      this.toastHandlerService.showToast(
        'warning',
        'Debe crear un traslado.'
      );
      return;
    }
    if (!this.permissionPrint) {
      this.toastHandlerService.showToast(
        'error',
        `El usuario no tiene permisos para imprimir traslados. Comuníquese con el administrador del sistema.`
      );
      return;
    }
    this.toastHandlerService.clearAllToasts();
    try {
      const { branchId, transferWorkshopStoreId } = this.transferWorkshopStoreContract;
      const response = await firstValueFrom(this.transferWorkshopStoreService.getTransferWorkshopStoreByKeysByPrint(branchId, 0,
        transferWorkshopStoreId));
      this.transferWorkshopStorePrintModel = response;
      this.reloadPrint = !this.reloadPrint;
    } catch (error) {
      console.error('Error al imprimir el traslado.', error);
    }
  }

  async send() {
    const model = this.formTransferWorkshopStore.getRawValue() as TransferWorkshopStoreModel;
    model.observation = model.observation?.trim() || null;

    if (this.transferWorkshopStoreId == 0) {
      await this.createTransferWorkshopStore(model);
    } else {
      await this.updateTransferStoreWorkshop(model);
    }
  }

  showValidationMessages(): void {
    const controlMessages: Record<string, Record<string, string>> = {
      branchId: {
        required: 'Debe seleccionar una Sucursal.',
        min: 'Debe seleccionar una Sucursal válida.'
      },
      transferWorkshopStoreState: {
        required: 'Debe seleccionar un Estado.',
        min: 'Debe seleccionar un Estado válido.'
      },
      dateTransferWorkshopStore: {
        required: 'Debe seleccionar una Fecha.'
      },
      swBlock: {
        required: 'Debe seleccionar el Bloqueo.'
      },
      type: {
        required: 'Debe seleccionar un Tipo.',
        min: 'Debe seleccionar un Tipo válido.'
      },
      observation: {
        maxlength: 'La Observación no puede tener más de 250 caracteres.'
      },
      mechanicId: {
        required: 'Debe seleccionar un Mecánico.',
        min: 'Debe seleccionar un Mecánico válido.'
      }
    };

    Object.keys(controlMessages).forEach(controlName => {
      const control = this.formTransferWorkshopStore.get(controlName);
      if (control && control.invalid && control.errors) {
        const messages = controlMessages[controlName];
        Object.keys(control.errors).forEach(errorKey => {
          const message = messages[errorKey];
          if (message) {
            this.toastHandlerService.showToast('warning', message);
          }
        });
      }
    });
  }

  async resetContract() {
    this.transferWorkshopStoreId = 0;
    this.transferWorkshopStoreContract = new TransferWorkshopStoreModel();
    this.transferWorkshopStoreContract.branchId = this.branchId;
    this.transferWorkshopStoreContract.mechanicId = this.mechanicId;
    this.validateForm(this.transferWorkshopStoreContract);
    this.location.replaceState(`/${this.url}/register`);
  }

  async updateTransferStoreWorkshop(modelTransferWorkshopStore: TransferWorkshopStoreModel) {
    this.transferWorkshopStoreContract.alterNumber = modelTransferWorkshopStore.alterNumber;
    this.transferWorkshopStoreContract.type = modelTransferWorkshopStore.type;
    this.transferWorkshopStoreContract.dateTransferWorkshopStore = modelTransferWorkshopStore.dateTransferWorkshopStore;
    this.transferWorkshopStoreContract.mechanicId = modelTransferWorkshopStore.mechanicId;
    this.transferWorkshopStoreContract.observation = modelTransferWorkshopStore.observation;
    try {
      const response = await firstValueFrom(this.transferWorkshopStoreService.updateAsync(this.transferWorkshopStoreContract));
      this.transferWorkshopStoreContract = response;
      this.validateForm(this.transferWorkshopStoreContract);
      this.toastHandlerService.showToast('success', `El traslado fue modificado exitosamente.`);
    } catch (error) {
      console.error('Error al modificar el traslado.', error);
    }
  }

  updateFormState(): void {
    const stateConfig: any = {
      [TransferWorkshopStoreStateEnums.open]: {
        icon: 'pi pi-lock-open',
        title: 'Cerrar',
        text: 'Abierta',
        isDisabled: false,
        severityState: 'danger',
        enableConsecutive: this.transferWorkshopStoreId !== 0
      },
      [TransferWorkshopStoreStateEnums.close]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Cerrada',
        isDisabled: true,
        severityState: 'success',
        enableConsecutive: true
      },
      [TransferWorkshopStoreStateEnums.annulled]: {
        icon: 'pi pi-lock',
        title: 'Abrir',
        text: 'Anulado',
        isDisabled: true,
        severityState: 'warn',
        enableConsecutive: true
      }
    };

    const currentState = this.transferWorkshopStoreContract.transferWorkshopStoreState;
    const config = stateConfig[currentState];
    if (!config) return;

    this.icon = config.icon;
    this.titleState = config.title;
    this.severityState = config.severityState;
    this.stateTransferStoreWorkshop = config.text;
    this.disabledForm = config.isDisabled || this.transferWorkshopStoreContract.swBlock;

    const form = this.formTransferWorkshopStore;

    if (!this.permissionUpdatable || this.transferWorkshopStoreContract.swBlock || config.isDisabled) {
      form.disable();
    } else {
      form.enable();
    }

    const consecutiveControl = form.controls['consecutive'];
    config.enableConsecutive ? consecutiveControl.enable() : consecutiveControl.disable();

    form.controls['swBlock'].enable();
    form.controls['branchId'].enable();
  }

  validateForm(transferWorkshopStore: TransferWorkshopStoreModel) {
    this.formTransferWorkshopStore = this.formBuilder.group({
      branchId: [transferWorkshopStore.branchId, [Validators.required, Validators.min(1)]],
      consecutive: [transferWorkshopStore.consecutive],
      alterNumber: [transferWorkshopStore.alterNumber],
      transferWorkshopStoreState: [transferWorkshopStore.transferWorkshopStoreState, [Validators.required, Validators.min(1)]],
      dateTransferWorkshopStore: [transferWorkshopStore.dateTransferWorkshopStore ?
        this.dateConverterService.convertUtcToLocalDate(transferWorkshopStore.dateTransferWorkshopStore) : null, [Validators.required]],
      swBlock: [transferWorkshopStore.swBlock, [Validators.required]],
      type: [transferWorkshopStore.type, [Validators.required, Validators.min(1)]],
      observation: [transferWorkshopStore.observation, [Validators.max(250)]],
      mechanicId: [transferWorkshopStore.mechanicId, [Validators.required, Validators.min(1)]]
    });
    this.updateFormState();
  }

  validateFormControls() {
    Object.keys(this.formTransferWorkshopStore.controls).forEach((key) => {
      const control = this.formTransferWorkshopStore.get(key);
      if (control && control.invalid) {
        console.warn(
          `${key} es inválido`,
          control.errors,
          'value:',
          control.value
        );
      }
    });
  }
}
